import React, { useState } from 'react'
import { ChevronDown, ChevronRight } from 'lucide-react'
import '../../styles/accordian.css'

function PropertyDetailsAccordian({
  title,
  children,
  defaultOpen = false,
  className = '',
}) {
  const [open, setOpen] = useState(defaultOpen)

  return (
    <div className={`property-details-accordion ${className}`}>
      <button
        type="button"
        className="property-details-accordion-header"
        onClick={() => setOpen(!open)}
      >
        <div className="property-details-accordion-title">
          {open ? (
            <ChevronDown size={16} />
          ) : (
            <ChevronRight size={16} />
          )}
          <span>{title}</span>
        </div>
      </button>

      {open && (
        <div className="property-details-accordion-body">
          {children}
        </div>
      )}
    </div>
  )
}

export default PropertyDetailsAccordian